/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component} from "@angular/core";

interface ExternalTool {
  name: string;
  url: string;
  logoUrl: string;
}

@Component({
  selector: "app-external-tools-list",
  templateUrl: "./external-tools-list.component.html",
  styleUrls: ["./external-tools-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExternalToolsListComponent {
  readonly externalTools: ExternalTool[] = [
    {
      name: "Kibana",
      url: `${location.origin}/system/kibana`,
      logoUrl: "assets/external-services/logo/kibana.svg",
    },
    {
      name: "Grafana",
      url: "http://trec-grafana.fbk.eu/",
      logoUrl: "assets/external-services/logo/grafana.svg",
    },
    {
      name: "Swagger",
      url: `${location.origin}/system/swagger/`,
      logoUrl: "assets/external-services/logo/swagger.svg",
    },
    {
      name: "Documentation",
      url: `${location.origin}/system/documentation`,
      logoUrl: "assets/external-services/logo/docsify.svg",
    },
    {
      name: "RabbitMQ",
      url: `${location.origin}/rabbitmq/`,
      logoUrl: "assets/external-services/logo/rabbitmq.svg",
    },
  ];

  onGoToExternalService(url: string) {
    window.open(url, "_blank");
  }
}
